"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-three/sections/bannerSection.tsx */

import { SmartImage } from "@/Components";
import { SmartLink } from "@/Components";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, ReactNode } from "react";

export type HomeThreeBannerSectionGeneratedProps = {
    /** Default: "We Take Care of" */
    divDiv0Div0Div0H10H1Text?: ReactNode;
    /** Default: "Your" */
    divDiv0Div0Div0H10H1Text2?: ReactNode;
    divDiv0Div0Div0H10H1Visible?: boolean;
    divDiv0Div0Div0H10H1Renderer?: (defaultNode: ReactNode) => ReactNode;
    divDiv0Div0Div0H10H1Props?: Partial<ComponentProps<"h1">>;
    /** Default: "icon" */
    divDiv0Div0Div0H10Span0ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/icons/banner-icon-2.png" */
    divDiv0Div0Div0H10Span0ImageWithBasePath0ImageSrc?: string;
    divDiv0Div0Div0H10Span0ImageWithBasePath0ImageVisible?: boolean;
    divDiv0Div0Div0H10Span0ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    divDiv0Div0Div0H10Span0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "Smile" */
    divDiv0Div0Div0H10Span1SpanText?: ReactNode;
    /** Default: "smile" */
    divDiv0Div0Div0H10Span1ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/about/smile-icon.png" */
    divDiv0Div0Div0H10Span1ImageWithBasePath0ImageSrc?: string;
    divDiv0Div0Div0H10Span1ImageWithBasePath0ImageVisible?: boolean;
    divDiv0Div0Div0H10Span1ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    divDiv0Div0Div0H10Span1ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "Experience gentle, personalized dental care designed to keep your smile healthy and radiant. From routine checkups to advanced treatments, we’re here to make every visit stress-free." */
    divDiv0Div0Div0P0PText?: ReactNode;
    /** Default: "Professional Services" */
    divDiv0Div0Div0P1PText?: ReactNode;
    /** Default: "icon" */
    divDiv0Div0Div0P1ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/icons/banner-icon-1.png" */
    divDiv0Div0Div0P1ImageWithBasePath0ImageSrc?: string;
    divDiv0Div0Div0P1ImageWithBasePath0ImageVisible?: boolean;
    divDiv0Div0Div0P1ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    divDiv0Div0Div0P1ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "Advanced Teammates" */
    divDiv0Div0Div0P2PText?: ReactNode;
    /** Default: "icon" */
    divDiv0Div0Div0P2ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/icons/banner-icon-3.png" */
    divDiv0Div0Div0P2ImageWithBasePath0ImageSrc?: string;
    divDiv0Div0Div0P2ImageWithBasePath0ImageVisible?: boolean;
    divDiv0Div0Div0P2ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    divDiv0Div0Div0P2ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "#" */
    divDiv0Div0Div1Link0LinkHref?: string;
    divDiv0Div0Div1Link0LinkVisible?: boolean;
    divDiv0Div0Div1Link0LinkRenderer?: (defaultNode: ReactNode) => ReactNode;
    divDiv0Div0Div1Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>>;
    /** Default: "View All Services" */
    divDiv0Div0Div1Link0Span0SpanText?: ReactNode;
    /** Default: "banner-img-three" */
    divDiv0Div1Div0ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/banner/banner-three-one.png" */
    divDiv0Div1Div0ImageWithBasePath0ImageSrc?: string;
    divDiv0Div1Div0ImageWithBasePath0ImageVisible?: boolean;
    divDiv0Div1Div0ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    divDiv0Div1Div0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "banner-img-three" */
    divDiv0Div1Div0ImageWithBasePath1ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/banner/banner-three-two.png" */
    divDiv0Div1Div0ImageWithBasePath1ImageSrc?: string;
    divDiv0Div1Div0ImageWithBasePath1ImageVisible?: boolean;
    divDiv0Div1Div0ImageWithBasePath1ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    divDiv0Div1Div0ImageWithBasePath1ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "banner-img-three" */
    divDiv0Div1Div0ImageWithBasePath2ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/banner/banner-three-three.png" */
    divDiv0Div1Div0ImageWithBasePath2ImageSrc?: string;
    divDiv0Div1Div0ImageWithBasePath2ImageVisible?: boolean;
    divDiv0Div1Div0ImageWithBasePath2ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    divDiv0Div1Div0ImageWithBasePath2ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "banner-img-three" */
    divDiv0Div1Div0ImageWithBasePath3ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/banner/banner-three-four.png" */
    divDiv0Div1Div0ImageWithBasePath3ImageSrc?: string;
    divDiv0Div1Div0ImageWithBasePath3ImageVisible?: boolean;
    divDiv0Div1Div0ImageWithBasePath3ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    divDiv0Div1Div0ImageWithBasePath3ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "banner-img-three" */
    divDiv0Div1Div0ImageWithBasePath4ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/banner/banner-three-five.png" */
    divDiv0Div1Div0ImageWithBasePath4ImageSrc?: string;
    divDiv0Div1Div0ImageWithBasePath4ImageVisible?: boolean;
    divDiv0Div1Div0ImageWithBasePath4ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    divDiv0Div1Div0ImageWithBasePath4ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "banner-img-three" */
    divDiv0Div1ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/banner-three-bg.png" */
    divDiv0Div1ImageWithBasePath0ImageSrc?: string;
    divDiv0Div1ImageWithBasePath0ImageVisible?: boolean;
    divDiv0Div1ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    divDiv0Div1ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "banner-bg-06" */
    divImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/banner-bg-06.png" */
    divImageWithBasePath0ImageSrc?: string;
    divImageWithBasePath0ImageVisible?: boolean;
    divImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    divImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
};

const HomeThreeBannerSectionGenerated: FC<HomeThreeBannerSectionGeneratedProps> = ({
    divDiv0Div0Div0H10H1Text = "We Take Care of",
    divDiv0Div0Div0H10H1Text2 = "Your",
    divDiv0Div0Div0H10H1Visible,
    divDiv0Div0Div0H10H1Renderer,
    divDiv0Div0Div0H10H1Props,
    divDiv0Div0Div0H10Span0ImageWithBasePath0ImageAlt = "icon",
    divDiv0Div0Div0H10Span0ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/icons/banner-icon-2.png",
    divDiv0Div0Div0H10Span0ImageWithBasePath0ImageVisible,
    divDiv0Div0Div0H10Span0ImageWithBasePath0ImageRenderer,
    divDiv0Div0Div0H10Span0ImageWithBasePath0ImageProps,
    divDiv0Div0Div0H10Span1ImageWithBasePath0ImageAlt = "smile",
    divDiv0Div0Div0H10Span1ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/about/smile-icon.png",
    divDiv0Div0Div0H10Span1ImageWithBasePath0ImageVisible,
    divDiv0Div0Div0H10Span1ImageWithBasePath0ImageRenderer,
    divDiv0Div0Div0H10Span1ImageWithBasePath0ImageProps,
    divDiv0Div0Div0H10Span1SpanText = "Smile",
    divDiv0Div0Div0P0PText = "Experience gentle, personalized dental care designed to keep your smile healthy and radiant. From routine checkups to advanced treatments, we’re here to make every visit stress-free.",
    divDiv0Div0Div0P1ImageWithBasePath0ImageAlt = "icon",
    divDiv0Div0Div0P1ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/icons/banner-icon-1.png",
    divDiv0Div0Div0P1ImageWithBasePath0ImageVisible,
    divDiv0Div0Div0P1ImageWithBasePath0ImageRenderer,
    divDiv0Div0Div0P1ImageWithBasePath0ImageProps,
    divDiv0Div0Div0P1PText = "Professional Services",
    divDiv0Div0Div0P2ImageWithBasePath0ImageAlt = "icon",
    divDiv0Div0Div0P2ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/icons/banner-icon-3.png",
    divDiv0Div0Div0P2ImageWithBasePath0ImageVisible,
    divDiv0Div0Div0P2ImageWithBasePath0ImageRenderer,
    divDiv0Div0Div0P2ImageWithBasePath0ImageProps,
    divDiv0Div0Div0P2PText = "Advanced Teammates",
    divDiv0Div0Div1Link0LinkHref = "#",
    divDiv0Div0Div1Link0LinkVisible,
    divDiv0Div0Div1Link0LinkRenderer,
    divDiv0Div0Div1Link0LinkProps,
    divDiv0Div0Div1Link0Span0SpanText = "View All Services",
    divDiv0Div1Div0ImageWithBasePath0ImageAlt = "banner-img-three",
    divDiv0Div1Div0ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/banner/banner-three-one.png",
    divDiv0Div1Div0ImageWithBasePath0ImageVisible,
    divDiv0Div1Div0ImageWithBasePath0ImageRenderer,
    divDiv0Div1Div0ImageWithBasePath0ImageProps,
    divDiv0Div1Div0ImageWithBasePath1ImageAlt = "banner-img-three",
    divDiv0Div1Div0ImageWithBasePath1ImageSrc = "/Templates/Doccure/img/banner/banner-three-two.png",
    divDiv0Div1Div0ImageWithBasePath1ImageVisible,
    divDiv0Div1Div0ImageWithBasePath1ImageRenderer,
    divDiv0Div1Div0ImageWithBasePath1ImageProps,
    divDiv0Div1Div0ImageWithBasePath2ImageAlt = "banner-img-three",
    divDiv0Div1Div0ImageWithBasePath2ImageSrc = "/Templates/Doccure/img/banner/banner-three-three.png",
    divDiv0Div1Div0ImageWithBasePath2ImageVisible,
    divDiv0Div1Div0ImageWithBasePath2ImageRenderer,
    divDiv0Div1Div0ImageWithBasePath2ImageProps,
    divDiv0Div1Div0ImageWithBasePath3ImageAlt = "banner-img-three",
    divDiv0Div1Div0ImageWithBasePath3ImageSrc = "/Templates/Doccure/img/banner/banner-three-four.png",
    divDiv0Div1Div0ImageWithBasePath3ImageVisible,
    divDiv0Div1Div0ImageWithBasePath3ImageRenderer,
    divDiv0Div1Div0ImageWithBasePath3ImageProps,
    divDiv0Div1Div0ImageWithBasePath4ImageAlt = "banner-img-three",
    divDiv0Div1Div0ImageWithBasePath4ImageSrc = "/Templates/Doccure/img/banner/banner-three-five.png",
    divDiv0Div1Div0ImageWithBasePath4ImageVisible,
    divDiv0Div1Div0ImageWithBasePath4ImageRenderer,
    divDiv0Div1Div0ImageWithBasePath4ImageProps,
    divDiv0Div1ImageWithBasePath0ImageAlt = "banner-img-three",
    divDiv0Div1ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/bg/banner-three-bg.png",
    divDiv0Div1ImageWithBasePath0ImageVisible,
    divDiv0Div1ImageWithBasePath0ImageRenderer,
    divDiv0Div1ImageWithBasePath0ImageProps,
    divImageWithBasePath0ImageAlt = "banner-bg-06",
    divImageWithBasePath0ImageSrc = "/Templates/Doccure/img/bg/banner-bg-06.png",
    divImageWithBasePath0ImageVisible,
    divImageWithBasePath0ImageRenderer,
    divImageWithBasePath0ImageProps,
}) => {
    return (
        <div className="hero-section-three">
            <div data-template-tag="HeaderSection" />
            <div className="banner-section-three">
                <div className="container">
                    <div className="banner-content-three">
                        {renderNode(divDiv0Div0Div0H10H1Visible, divDiv0Div0Div0H10H1Renderer, (
                            <h1 className="title" {...(divDiv0Div0Div0H10H1Props ?? {})}>
                                {divDiv0Div0Div0H10H1Text}
                                <br />
                                {" "}
                                <span className="icon">
                                    {renderNode(divDiv0Div0Div0H10Span0ImageWithBasePath0ImageVisible, divDiv0Div0Div0H10Span0ImageWithBasePath0ImageRenderer, (
                                        <SmartImage src={divDiv0Div0Div0H10Span0ImageWithBasePath0ImageSrc} alt={divDiv0Div0Div0H10Span0ImageWithBasePath0ImageAlt} className="img-fluid element-1" {...(divDiv0Div0Div0H10Span0ImageWithBasePath0ImageProps ?? {})} />
                                    ))}
                                </span>
                                {" "}
                                {divDiv0Div0Div0H10H1Text2}
                                {" "}
                                <span className="text-primary smile-icon">
                                    {divDiv0Div0Div0H10Span1SpanText}
                                    {" "}
                                    {renderNode(divDiv0Div0Div0H10Span1ImageWithBasePath0ImageVisible, divDiv0Div0Div0H10Span1ImageWithBasePath0ImageRenderer, (
                                        <SmartImage src={divDiv0Div0Div0H10Span1ImageWithBasePath0ImageSrc} alt={divDiv0Div0Div0H10Span1ImageWithBasePath0ImageAlt} className="img-1" {...(divDiv0Div0Div0H10Span1ImageWithBasePath0ImageProps ?? {})} />
                                    ))}
                                </span>
                                {" "}
                            </h1>
                        ))}
                        <p className="description">{divDiv0Div0Div0P0PText}</p>
                        <p className="float-text1">
                            {renderNode(divDiv0Div0Div0P1ImageWithBasePath0ImageVisible, divDiv0Div0Div0P1ImageWithBasePath0ImageRenderer, (
                                <SmartImage src={divDiv0Div0Div0P1ImageWithBasePath0ImageSrc} alt={divDiv0Div0Div0P1ImageWithBasePath0ImageAlt} className="img-fluid icon-1" {...(divDiv0Div0Div0P1ImageWithBasePath0ImageProps ?? {})} />
                            ))}
                            {divDiv0Div0Div0P1PText}
                        </p>
                        <p className="float-text2">
                            {renderNode(divDiv0Div0Div0P2ImageWithBasePath0ImageVisible, divDiv0Div0Div0P2ImageWithBasePath0ImageRenderer, (
                                <SmartImage src={divDiv0Div0Div0P2ImageWithBasePath0ImageSrc} alt={divDiv0Div0Div0P2ImageWithBasePath0ImageAlt} className="img-fluid icon-2" {...(divDiv0Div0Div0P2ImageWithBasePath0ImageProps ?? {})} />
                            ))}
                            {divDiv0Div0Div0P2PText}
                        </p>
                    </div>
                    <div className="banner-btn-three">
                        {renderNode(divDiv0Div0Div1Link0LinkVisible, divDiv0Div0Div1Link0LinkRenderer, (
                            <SmartLink href={divDiv0Div0Div1Link0LinkHref} className="theme-2-btn" {...(divDiv0Div0Div1Link0LinkProps ?? {})}>
                                {" "}
                                <span>
                                    {divDiv0Div0Div1Link0Span0SpanText}
                                    {" "}
                                    <span className="icon">
                                        <i className="isax isax-arrow-up-34" />
                                    </span>
                                </span>
                            </SmartLink>
                        ))}
                    </div>
                </div>
                <div className="banner-img-three">
                    {renderNode(divDiv0Div1ImageWithBasePath0ImageVisible, divDiv0Div1ImageWithBasePath0ImageRenderer, (
                        <SmartImage src={divDiv0Div1ImageWithBasePath0ImageSrc} alt={divDiv0Div1ImageWithBasePath0ImageAlt} className="img-fluid banner-3-bg" {...(divDiv0Div1ImageWithBasePath0ImageProps ?? {})} />
                    ))}
                    <div className="container img-list">
                        {renderNode(divDiv0Div1Div0ImageWithBasePath0ImageVisible, divDiv0Div1Div0ImageWithBasePath0ImageRenderer, (
                            <SmartImage src={divDiv0Div1Div0ImageWithBasePath0ImageSrc} alt={divDiv0Div1Div0ImageWithBasePath0ImageAlt} className="img-fluid img-1" {...(divDiv0Div1Div0ImageWithBasePath0ImageProps ?? {})} />
                        ))}
                        {renderNode(divDiv0Div1Div0ImageWithBasePath1ImageVisible, divDiv0Div1Div0ImageWithBasePath1ImageRenderer, (
                            <SmartImage src={divDiv0Div1Div0ImageWithBasePath1ImageSrc} alt={divDiv0Div1Div0ImageWithBasePath1ImageAlt} className="img-fluid img-2" {...(divDiv0Div1Div0ImageWithBasePath1ImageProps ?? {})} />
                        ))}
                        {renderNode(divDiv0Div1Div0ImageWithBasePath2ImageVisible, divDiv0Div1Div0ImageWithBasePath2ImageRenderer, (
                            <SmartImage src={divDiv0Div1Div0ImageWithBasePath2ImageSrc} alt={divDiv0Div1Div0ImageWithBasePath2ImageAlt} className="img-fluid img-3" {...(divDiv0Div1Div0ImageWithBasePath2ImageProps ?? {})} />
                        ))}
                        {renderNode(divDiv0Div1Div0ImageWithBasePath3ImageVisible, divDiv0Div1Div0ImageWithBasePath3ImageRenderer, (
                            <SmartImage src={divDiv0Div1Div0ImageWithBasePath3ImageSrc} alt={divDiv0Div1Div0ImageWithBasePath3ImageAlt} className="img-fluid img-4" {...(divDiv0Div1Div0ImageWithBasePath3ImageProps ?? {})} />
                        ))}
                        {renderNode(divDiv0Div1Div0ImageWithBasePath4ImageVisible, divDiv0Div1Div0ImageWithBasePath4ImageRenderer, (
                            <SmartImage src={divDiv0Div1Div0ImageWithBasePath4ImageSrc} alt={divDiv0Div1Div0ImageWithBasePath4ImageAlt} className="img-fluid img-5" {...(divDiv0Div1Div0ImageWithBasePath4ImageProps ?? {})} />
                        ))}
                    </div>
                </div>
            </div>
            {renderNode(divImageWithBasePath0ImageVisible, divImageWithBasePath0ImageRenderer, (
                <SmartImage src={divImageWithBasePath0ImageSrc} alt={divImageWithBasePath0ImageAlt} className="img-fluid element-01" {...(divImageWithBasePath0ImageProps ?? {})} />
            ))}
        </div>
    );
};

export default HomeThreeBannerSectionGenerated;
